import { Box, styled, Typography } from "@mui/material";
import { ReactComponent as CartScreenImage } from "../../../assets/images/cart-screen-image.svg";
import { ReactComponent as HomeScreenImage } from "../../../assets/images/home-screen-image.svg";
import { getIcon } from "../../../utils/iconConfig";
import RestrictedCard from "../cards/restrictedCard/RestrictedCard";

const EmptyScreen = ({ page }) => {
  const data = JSON.parse(localStorage.getItem("ClientData"));
  let clientName =
    data?.name === "Binnys Jewellery Pvt. Ltd. (Client not Found)"
      ? data.newClientName
      : data?.name;

  const StyledHeader = styled(Typography)(({ theme }) => ({
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: "1.1vw",
    lineHeight: "100%",
    marginBottom: ".05vw",
  }));

  const StyledDesc = styled(Typography)(({ theme }) => ({
    alignSelf: "center",
    fontFamily: "Poppins",
    color: "#B3B3B3",
    fontWeight: 400,
    fontSize: ".7vw",
    lineHeight: "100%",
    cursor: "pointer",
  }));

  return (
    <Box
      margin={"auto"}
      width="fit-content"
      display={"flex"}
      flexDirection={"column"}
      alignItems={"center"}
    >
      {page === "home" ? <HomeScreenImage /> : <CartScreenImage />}
      <Box marginTop="1vw" display="flex" flexDirection="column" gap=".5vw">
        {data && <StyledHeader>Hi, {clientName}</StyledHeader>}
        <StyledDesc>
          {page === "home"
            ? "please Scan Design to proceed"
            : clientName
            ? "Cart is empty right now!"
            : "No Client selected"}{" "}
          {page === "home" && getIcon("RightArrow")}
        </StyledDesc>
        {/* <RestrictedCard /> */}
      </Box>
    </Box>
  );
};

export default EmptyScreen;

